var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ClosedTask from '@/modules/tasks/taskboard/kanban/task/ClosedTask';
import { useGetPlannedTaskRemark } from '@/shared/hooks/task/useGetPlannedTaskRemark';
import classNames from 'classnames';
import { useState } from 'react';
import OpenTask from './OpenTask';
var TaskRow = function (_a) {
    var task = _a.task, isCollapsed = _a.isCollapsed, onSetIsCollapsed = _a.onSetIsCollapsed;
    var _b = useState(false), loadRemark = _b[0], setLoadRemark = _b[1];
    var _c = useGetPlannedTaskRemark(task.id, 0, task.scheduleHasRemark, loadRemark), data = _c.data, loading = _c.isLoading;
    var collapseTask = function (t) {
        onSetIsCollapsed(t);
    };
    var retrieveRemark = function () {
        setLoadRemark(true);
    };
    return (_jsxs("tr", __assign({ className: classNames('dskb-row dskb-group-row', isCollapsed ? 'dskb-group-collapsed' : null) }, { children: [_jsx("td", __assign({ className: "dskb-cell dskb-header dskb-row-header dskb-toggle-button-area clickable", onClick: function () { return collapseTask(task); } }, { children: _jsx("svg", __assign({ className: "dskb-toggle-button", width: "8", height: "8" }, { children: isCollapsed ? (_jsx("polygon", { points: "0,0 6,4 0,8", className: "dskb-toggle-button-collapsed" })) : (_jsx("polygon", { points: "1,7 7,7 7,1", className: "dskb-toggle-button-expanded" })) })) })), isCollapsed ? (_jsx(ClosedTask, { task: task, collapseTask: collapseTask, retrieveRemark: retrieveRemark, remark: data, loadingRemark: loading })) : (_jsx(OpenTask, { task: task, retrieveRemark: retrieveRemark, remark: data, loadingRemark: loading }))] })));
};
export default TaskRow;
